import { initializeApp, getApps } from 'firebase/app';
import { getToken, onMessage, getMessaging } from 'firebase/messaging';
import { getAuth, GoogleAuthProvider, RecaptchaVerifier } from 'firebase/auth';
import { firebaseConfig, VAPID_KEY } from './config';

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Exporting Services
export const auth = getAuth(app);
export const messaging =
  typeof window !== 'undefined' && 'serviceWorker' in navigator ? getMessaging(app) : null;
export const googleAuthProvider = new GoogleAuthProvider();

export { app, RecaptchaVerifier };

// Request permission for notifications
export const requestPermission = async () => {
  if (!messaging || !('serviceWorker' in navigator)) return;
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const registration = await navigator.serviceWorker.ready;
      const token = await getToken(messaging, {
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration: registration,
      });
      localStorage.setItem('fcm_token', token);
      return token;
    }
  } catch (error) {
    console.error('Error getting notification permission:', error);
  }
};

// Handle incoming messages
export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) return;
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
